// extracted by mini-css-extract-plugin
export default {"totalQ":"AddToCartPage_totalQ__CIjHT"};